import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { RecuperarContrasenaService } from '../_services';
import { first } from 'rxjs/operators';
var RecuperaContrasenaComponent = /** @class */ (function () {
    function RecuperaContrasenaComponent(formBuilder, route, router, recuperarContrasenaService) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.recuperarContrasenaService = recuperarContrasenaService;
        this.submitted = false;
    }
    RecuperaContrasenaComponent.prototype.ngOnInit = function () {
        this.formRecuperar = this.formBuilder.group({
            username: ['', Validators.required]
        });
    };
    Object.defineProperty(RecuperaContrasenaComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () {
            return this.formRecuperar.controls;
        },
        enumerable: true,
        configurable: true
    });
    RecuperaContrasenaComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        console.log('Submit form recuperar contraseña');
        // stop here if form is invalid
        if (this.formRecuperar.invalid) {
            return;
        }
        this.recuperarContrasenaService
            .postRecuperarContrasena(this.f.username.value)
            .pipe(first())
            .subscribe(function (data) {
            if (data['id']) {
                alert('Recibirá un email con la contraseña nueva');
                _this.submitted = false;
                _this.f.username.setValue('');
            }
            else {
                alert('Usuario no válido: ' + data['message']);
                _this.submitted = false;
            }
        });
    };
    return RecuperaContrasenaComponent;
}());
export { RecuperaContrasenaComponent };
